import React, { Component } from 'react';
import {connect} from  'react-redux';
import { Link } from 'react-router-dom';
import ReactTable from "react-table";
import "react-table/react-table.css";
import TmExportExcel from '../../../UtilComponents/tmExportExcel/tmExportExcel';
import {utilMethods} from '../../../../util/util';
class ExpiredAccountDetails extends Component {
    constructor() {
        super();
        this.state = {
            excelDataSet:[]
        };
        this.buildDataFormatForExport=this.buildDataFormatForExport.bind(this);
      }
      componentWillMount=()=>{
       this.setState({
  excelDataSet: this.props.adminDashboard_All_Accounts.filter(item => {
    return new Date(item.expireDate) < new Date() && item.isActive !== 0
  })
});
      }
      componentWillReceiveProps=(nextProps)=>{
       this.setState({
  excelDataSet: nextProps.adminDashboard_All_Accounts.filter(item => {
    return new Date(item.expireDate) < new Date() && item.isActive !== 0
  })
});
      }
      buildDataFormatForExport=()=>{
        return([{
          columns:[{title:'Account Name'},{title:'Expired Date'}],
          data: this.state.excelDataSet.map((item)=>{
            return [{value:item.accountName || ''},{value:item.expireDate || ''}]
          })
        }])
      }
    render() {
        const { adminDashboard_All_Accounts } = this.props;
        return (
            <div className="row">
                <div className="col-md-9">
                <h4><i class="fa fa-history"></i> Expired Accounts</h4>
                </div>
                <div className="col-md-3">
                <TmExportExcel name={'Expired Accounts'} filename={'Expired_Accounts'} 
                    element={<button className="btn btn-warning btn-sm mr-15"><i className="fa fa-file-excel-o"></i> Export</button>}
                    dataSet={this.buildDataFormatForExport()} />
                <Link class="btn btn-info" to="/admin-dashboard"><i class="fa fa-arrow-left" aria-hidden="true"></i> Back </Link>
                </div>
                <div className="col-md-12">
                <ReactTable ref={(t)=>this.expiryTable=t}
                       data={adminDashboard_All_Accounts.filter(item => {
  return new Date(item.expireDate) < new Date() && item.isActive != 0
})}
                        columns={[
                            {
                                Header:'Account Name',
                                accessor:'accountName'
                            },
                            {
                                Header:'Expired Date',
                                accessor:'expireDate'
                            }
                        ]}
                        onFilteredChange={()=>{
                            let expiredAccounts=this.expiryTable.getResolvedState().sortedData;
                            this.setState({excelDataSet:expiredAccounts});
                          }}
                        defaultPageSize={10}
                        className="-striped -highlight"
                        filterable="true"
                        defaultFilterMethod={(filter, row)=> {
                            const id = filter.pivotId || filter.id;
                            return (
                              row[id] !== undefined ?
                              utilMethods.isNumber(row[id])? (row[id].toString()).includes(filter.value):
                                String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
                              :
                                true
                            )}}
                        />
                </div>  
            </div>                                                    
        );
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        adminDashboard_All_Accounts: state.adminDashboard.allAccounts  
    }
};
export default connect(mapStateToProps)(ExpiredAccountDetails);